/**
 * Created by Kristy on 25/8/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PendingHistoryController', PendingHistoryController);

    PendingHistoryController.$inject = ['$http','$state', '$stateParams','$filter', '$timeout', 'KendoGrid', 'KendoFilter'];

    function PendingHistoryController ($http, $state, $stateParams, $filter, $timeout, KendoGrid, KendoFilter) {
        var vm = this;
        vm.saw = true;
        vm.sectorType = null;

        vm.customerTypesDataSource = new kendo.data.DataSource({
            transport: {
                read: function (o) {
                    if (o.data.filter == undefined) {
                        o.data.filter = {filters: []};
                    }

                    o.data.page = 1;
                    o.data.pageSize = 10;
                    $http.get('api/masterdata/customer-types',
                        {params: o.data})
                        .success(function (response, status, headers) {
                            o.success(response.content);
                        })
                        .error(function (response) {
                            console.log(response);
                        });
                }
            }
        });

        vm.customerTypesMultiOptions = {
            dataSource: vm.customerTypesDataSource,
            filter: "startswith",
            valuePrimitive: false,
            dataTextField: "name",
            dataValueField: "id"
        };

        vm.statusDataSource = new kendo.data.DataSource({
            data: [
                { value: 'approved', text: "ΕΓΚΡΙΘΗΚΕ"},
                { value: 'rejected',  text: "ΑΠΟΡΡΙΦΘΗΚΕ"}
            ]
        });

        vm.pendingHistoryGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter == undefined) {
                            o.data.filter = { filters: [] };
                        }

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "status", "operator": "noteq",  "value": "pending"}
                            ]
                        );

                        o.data.filter.filters = o.data.filter.filters.concat(
                            [
                                { "field": "sectorType", "operator": "sectortype",  "value": vm.sectorType}
                            ]
                        );

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        $http.get('api/me/temp-customers',
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){
                                item.newSector = false;
                                item.selectedIndex = 0;

                                if (item.doctorSpecialty === null) {
                                    item.doctorSpecialty = { id: null, name: "" };
                                }
                                if (item.doctorSpecificSpecialty === null) {
                                    item.doctorSpecificSpecialty = { id: null, name: "" };
                                }
                                if (item.customerCategory === null) {
                                    item.customerCategory = { id: null, name: "" };
                                }
                                if (item.customerSubCategory === null) {
                                    item.customerSubCategory = { id: null, name: "" };
                                }
                                if (item.customerTitle === null) {
                                    item.customerTitle = { id: null, name: "" };
                                }

                                if(item.tempCustomerSectors === null) {
                                    item.tempCustomerSectors = [];
                                }
                                angular.forEach(item.tempCustomerSectors, function (tempCustomerSector){
                                    if(tempCustomerSector.sector) {
                                        tempCustomerSector.displaySector = tempCustomerSector.sector;
                                    } else {
                                        item.newSector = true;
                                        tempCustomerSector.newSector = true;
                                        tempCustomerSector.displaySector = tempCustomerSector.tempSector;
                                    }

                                    if(tempCustomerSector.tempSector === null) {
                                        tempCustomerSector.tempSector = { sectorType: {} };
                                    } else if (tempCustomerSector.tempSector.sectorType === null){
                                        tempCustomerSector.tempSector.sectorType= {};
                                    }

                                    if(tempCustomerSector.sector === null) {
                                        tempCustomerSector.sector = { sectorType: {} };
                                    } else if (tempCustomerSector.sector.sectorType === null){
                                        tempCustomerSector.sector.sectorType= {};
                                    }
                                });
                            });
                        }

                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            createdDate: {type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 50
            }),
            sortable: true,
            pageable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.pendingHistoryGridOptions.dataSource.total()}}</label></div>",
                    overflow: "never" }],
            columns: [
                {field: "createdDate", title: "Ημερομηνία", template: "#= createdDate ? kendo.toString(kendo.parseDate(createdDate), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    },
                    width:200
                },
                {
                    title: "Νέα",
                    template: kendo.template(angular.element("#labelsTemplate").html()), width:50
                },
                {field: "lastName", title: "Επώνυμο Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "firstName", title: "Όνομα Επαγγελματία Υγείας",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",
                    filterable: {
                        cell: {
                            operator: "startswith",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    },
                    width:160
                },
                {
                    title: "Συνδέσεις",
                    template:"<span class='label label-warning'>#: tempCustomerSectors.length#</span>", width:80
                },
                {field: "status", title: "Κατάσταση",
                    template: "#= (status == 'approved') ? 'ΕΓΚΡΙΘΗΚΕ' : (status == 'rejected') ? 'ΑΠΟΡΡΙΦΘΗΚΕ' : '' #",
                    attributes: {
                        class: "#=status == 'approved' ? 'green' : status == 'rejected' ? 'red' : 'black' #"
                    },
                    filterable: {
                        cell: {
                            operator: "startswith",
                            showOperators: false,
                            template: function (args) {
                                args.element.kendoDropDownList({
                                    autoBind:false,
                                    dataSource: vm.statusDataSource,
                                    dataTextField: "text",
                                    dataValueField: "value",
                                    valuePrimitive: true

                                })
                            }
                        }
                    },
                    width:160
                }
            ]
        };

        vm.sectorTypeOptions = {
            dataSource: [
                { text: 'Φαρμακοποιοί', value: "pharmacy" },
                { text: 'Επαγγελματίες Υγείας', value: "hcu" },
                { text: 'Υπεύθυνοι Κέντρου', value: "beautyCenter" }
            ],
            filter: "startswith",
            valuePrimitive: true,
            dataTextField: "text",
            dataValueField: "value",
            change: function () {
                var self = this;
                $timeout(function() {
                    vm.sectorType = self.value();
                    vm.pendingHistoryGridOptions.dataSource.read();
                });
            }
        };

        vm.toolbarOptions = {
            items: [
                {
                    template: "<label>Τύπος Επαγγελματία Υγείας: </label><select id='sectorType' name='sectorType' class='inline' kendo-combo-box " +
                    "k-options='vm.sectorTypeOptions'></select>",
                    overflow: "never", attributes: { class: "left" }
                }
            ]
        };
    }
})();
